import { createFileRoute } from '@tanstack/react-router'
import ResetPasswordPage from '@/spa/pages/ResetPasswordPage'
import { routeErrorComponent } from './_shared/RouteError'

export const Route = createFileRoute('/reset-password')({
  component: ResetPasswordPage,
  errorComponent: routeErrorComponent,
})
